import React, { useState } from "react";
import "./FAQ.css"; // Import external CSS

const faqs = [
  {
    question: "What is AMPP?",
    answer:
      "AMPP stands for Association for Materials Protection and Performance, an international organization focused on corrosion control and protective coatings."
  },
  {
    question: "Why should I get AMPP certified?",
    answer:
      "AMPP certification validates your skills, boosts your professional credibility, and opens up more career opportunities in corrosion control and coating industries."
  },
  {
    question: "Which AMPP certifications are offered at ICCI?",
    answer:
      "ICCI offers CIP, CCI, and CP certifications, each designed to address different areas of corrosion control and inspection."
  },
  {
    question: "Do I need prior experience to join?",
    answer:
      "Some certifications require prior industry experience, while others are open to beginners. Check the specific course details for eligibility."
  },
  {
    question: "Where are the training programs conducted?",
    answer:
      "Training programs are conducted at ICCI’s training centers across India. Some courses may also be available online."
  },
  {
    question: "How do I register for a certification course?",
    answer:
      "You can register directly through our website or contact our support team for assistance with the enrollment process."
  },
  {
    question: "Are the certifications internationally recognized?",
    answer:
      "Yes, AMPP certifications are recognized globally and highly valued in industries such as oil & gas, marine, infrastructure, and manufacturing."
  },
  {
    question: "What support does ICCI provide after certification?",
    answer:
      "ICCI provides career guidance, job opportunity updates, and continuous professional development resources for certified professionals."
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <p className="faq-subtitle">
        Find quick answers to common questions about our courses, certifications,
        training locations, and more, all in one place.
      </p>
      {faqs.map((faq, index) => (
        <div
          key={index}
          className={`faq-item ${openIndex === index ? "active" : ""}`}
          onClick={() => toggleFAQ(index)}
        >
          <div className="faq-question">
            <span>{faq.question}</span>
            <span className="faq-icon">{openIndex === index ? "▲" : "▼"}</span>
          </div>
          {openIndex === index && (
            <p className="faq-answer">{faq.answer}</p>
          )}
        </div>
      ))}
    </div>
  );
}
